<template>
  <div id="coinList">
    <mt-header fixed :title="$t('选择币种')">
      <mt-button
        icon="back"
        slot="left"
        @click.native="$router.back()"
      ></mt-button>
    </mt-header>
    <div ref="main_list" class="main_list">
      <ul class="content_detail main_show">
        <li v-for="(item, index) in CoinsList" style="position: relative">
          <!-- <div class="selectCoin" @click="openLlist(index)">
            <img
              v-bind:src="close"
              alt=""
              :style="{
                // display: item.token_list.data.length == 0 ? 'none' : 'block',
                display: 'none',
              }"
            />
          </div> -->
          <div @click="CoinName(item.id, item.coin_symbol, item.img_url)">
            <img v-bind:src="item.img_url" alt="" class="oImg" />
            <span class="currency_name">
              <span class="receive wx_fontSize3">{{ item.coin_symbol }}</span>
              <span class="form wx_fontSize2">{{ item.coin_name }}</span>
            </span>
          </div>
          <!-- 剩余的子币种 暂时弃用 -->
          <!-- <ul class="content_detail childList">
            <li
              v-for="(val, key) in item.token_list.data"
              v-if="item.token_list.data.length > 0"
            >
              <div @click="CoinName(val.id, val.coin_symbol, val.img_url)">
                <img v-bind:src="val.img_url" alt="" class="oImg" />
                <span class="currency_name">
                  <span class="receive wx_fontSize3">{{
                    val.coin_symbol
                  }}</span>
                  <span class="form wx_fontSize2">{{ val.coin_name }}</span>
                </span>
              </div>
            </li>
          </ul> -->
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { httpCloudCoins, httpHDcoins } from "@/api/index";
import { Toast } from "mint-ui";
import { validateEmpty } from "@/utils/validate";
export default {
  data() {
    return {
      title: "",
      CoinsList: "",
      open: require("../../assets/img/login_ico_xia.png"),
      close: require("../../assets/img/ico_shouqi_tjbz.png"),
      name: {},
      type: 1,
    };
  },
  activated() {
    this.type = this.$route.query.type;
    this.addList();
  },
  methods: {
    addList(status) {
      if (this.type == 1) {
        // 获取与云端钱包币种列表
        httpCloudCoins({ status: "all" })
          .then((res) => {
            this.CoinsList = [];
            this.CoinsList = Object.values(res.data.list);
            console.log(this.CoinsList);
          })
          .catch(() => {});
      } else if (this.type == 2) {
        httpHDcoins({ status: "all" })
          .then((res) => {
            this.CoinsList = [];
            this.CoinsList = res.data.list;
          })
          .catch(() => {});
      }
    },

    // openLlist(index) {
    //   console.log(this.CoinsList);
    //   var tabCardCollection = document.querySelectorAll(".childList");
    //   var len = tabCardCollection.length;
    //   if (
    //     tabCardCollection[index].style.display == "none" ||
    //     tabCardCollection[index].style.display == ""
    //   ) {
    //     tabCardCollection[index].style.display = "block";
    //   } else {
    //     tabCardCollection[index].style.display = "none";
    //   }
    // },
    // 点击选择币种
    CoinName(id, name, img_url) {
      this.name = { name: name, id: id, img_url: img_url };
      this.$router.go(-1);
    },
  },
  beforeRouteLeave(to, from, next) {
    if (validateEmpty(this.name.name)) {
      // Toast('您未选择币种');
      next();
      return;
    }
    to.query.result = this.name;
    next();
  },
};
</script>

<style scoped>
#coinList {
  width: 100%;
  height: 100%;
}
.mint-header {
  background: #fff;
  color: #212529;
  border-bottom: 1px solid #e3e8ed;
}
.mint-button--default {
  color: #656b79 !important;
}
.main_list {
  padding: 40px 15px 0 15px;
}
.main_show {
  width: 100%;
}
.childList {
  width: 80%;
  margin-left: 20%;
  display: none;
}
.content_detail li {
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #e3e8ed;
}
.oImg {
  width: 40px;
  height: 40px;
  margin: 10px 14px 9px 0px;
  border: 1px solid #dddddd;
  border-radius: 50%;
  margin-left: 10px;
}
.content_detail li .selectCoin {
  width: 36px;
  height: 100%;
  position: absolute;
  top: 0px;
  left: -2%;
}
.selectCoin img {
  width: 12px;
  height: 7px;
  position: relative;
  top: 30px;
}
.currency_name {
  position: relative;
  display: inline-block;
  top: -34px;
}
.receive {
  position: absolute;
  top: 0;
  white-space: nowrap;
}
.form {
  position: relative;
  top: 25px;
  color: #8c92a8;
}
.amount_of {
  width: 20%;
  text-align: right;
  padding: 5px 0;
  border: 1px solid #1296db;
  text-align: center;
  margin-top: 17px;
  color: #1296db;
}
</style>
